import SideNavDecoration from './side-nav-decoration';

export * from './side-nav-decoration';

export default SideNavDecoration;
